function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { pickBy } from 'lodash';
import { BiContainer, BiProvider } from 'seagull';
import { useIoContext, useStore } from "../../contexts";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { selectors } from "../../store/state-selectors";
import { usePageViewTracking } from "./usePageViewTracking/usePageViewTracking";
import { jsx as _jsx } from "react/jsx-runtime";
const BiPageTrackingProvider = _ref => {
  let {
    children
  } = _ref;
  const [pageBiData, setPageBiData] = useState(undefined);
  usePageViewTracking({
    setPageBiData
  });
  return /*#__PURE__*/_jsx(BiContainer, {
    name: pageBiData === null || pageBiData === void 0 ? void 0 : pageBiData.pageName,
    data: pageBiData === null || pageBiData === void 0 ? void 0 : pageBiData.pageEvent,
    children: children
  });
};
export const BiFrontendProvider = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    logBIEvent: _logBIEvent
  } = useIoContext();
  const business_id = useStore(selectors.user.businessId);
  const user_id = useStore(selectors.user.id);
  const business_type = useStore(selectors.user.isVendor) ? 'service_provider' : 'client';
  const baseBiEventRef = useRef({});
  const ff = useFeatureFlags();
  const openedFeatureFlags = useMemo(() => pickBy(ff), [ff]);
  baseBiEventRef.current = {
    user_id,
    business_id,
    business_type,
    ff: openedFeatureFlags
  };
  const logBIEvent = useCallback(biEvent => {
    _logBIEvent(_objectSpread(_objectSpread({}, baseBiEventRef.current), biEvent));
  }, [_logBIEvent]);
  return /*#__PURE__*/_jsx(BiProvider, {
    logBi: logBIEvent,
    children: /*#__PURE__*/_jsx(BiPageTrackingProvider, {
      children: children
    })
  });
};